import Home from '../views/Public/Home.vue'
import NotFound from '../views/Public/NotFound.vue'
import {
	ensurePublicCalendarBootstrap,
	redirectPublicCalendarToFirst,
} from './guards/publicCalendarRedirect'

/**
 * Routes for the public share artifact only.
 * Do not import office/auth views here — they would be pulled into the public bundle.
 */
export const publicRoutes = [
	{
		path: '/',
		redirect: { name: 'public.not-found' },
	},
	{
		path: '/404',
		name: 'public.not-found',
		component: NotFound,
	},
	{
		path: '/:shortId([A-Za-z0-9]+)/calendars/:id',
		name: 'public.calendar.show',
		component: Home,
		beforeEnter: ensurePublicCalendarBootstrap,
	},
	{
		path: '/:shortId([A-Za-z0-9]+)/calendars',
		name: 'public.calendar',
		component: Home,
		beforeEnter: redirectPublicCalendarToFirst,
	},
	{
		path: '*',
		redirect: { name: 'public.not-found' },
	},
]
